import axios from "axios";

export const createAdmin = async (data: any) =>
  await axios.post("/admin/", data);

export const getAllAdmin = async () => await axios.get("/admin");

export const getMyDetail = async () => await axios.get("/admin/detail/");

export const adminLogin = async (data: any) =>
  await axios.post("/admin/login", data);
